import React, { useEffect, useState } from "react";
import { HiOutlineTrash } from "react-icons/hi";

// Props:
// - item: original cart item object
// - image: image url
// - title: product title
// - unitPrice: number
// - quantity: initial quantity
// - onQuantityChange(newQty)
// - onRemove()

export default function CartProductCard({ item, image, title, unitPrice, quantity = 1, onQuantityChange, onRemove }) {
  const [qty, setQty] = useState(Number(quantity) || 1);

  useEffect(() => {
    setQty(Number(quantity) || 1);
  }, [quantity]);

  function changeQty(newQty) {
    if (newQty < 1) return;
    setQty(newQty);
    if (typeof onQuantityChange === "function") onQuantityChange(newQty);
  }

  const totalPrice = (Number(unitPrice) || 0) * qty;
  const currencySymbol = item?.seller?.currency_symbol || "$";

  return (
    <div
      className="w-full max-w-[554px] min-h-[124px] bg-white border border-[#E5E5E5] rounded-[16px] shadow-sm hover:shadow-md transition-shadow p-4 flex flex-col sm:flex-row gap-4 items-center"
      style={{ fontFamily: 'Poppins, Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial' }}
    >
      {/* Image */}
      <div className="flex-shrink-0 w-full sm:w-[96px] bg-gray-50 rounded-md flex items-center justify-center overflow-hidden">
        <img src={image} alt={title} className="w-full sm:w-[96px] sm:h-[96px] object-contain" />
      </div>

      {/* Title + variant */}
      <div className="flex-1 min-w-0">
        <div className="text-sm font-medium text-gray-900 truncate">{title}</div>
        {item?.variant_name && (
          <div className="text-xs text-gray-500 mt-1 truncate">{item.variant_name}</div>
        )}
      </div>

      {/* Price */}
      <div className="w-[100px] text-right">
        <div className="text-sm text-gray-700">{currencySymbol}{totalPrice.toFixed(2)}</div>
        <div className="text-xs text-gray-400">{currencySymbol}{(Number(unitPrice) || 0).toFixed(2)} each</div>
      </div>

      {/* Quantity selector */}
      <div className="flex flex-col items-center gap-2">
        <div className="flex items-center border rounded-md overflow-hidden">
          <button
            aria-label="decrease"
            onClick={() => changeQty(qty - 1)}
            className="px-3 py-1 text-sm text-white bg-[#2B4E3E] hover:opacity-90"
          >
            -
          </button>
          <div className="px-3 py-1 text-sm">{qty}</div>
          <button
            aria-label="increase"
            onClick={() => changeQty(qty + 1)}
            className="px-3 py-1 text-sm text-white bg-[#2B4E3E] hover:opacity-90"
          >
            +
          </button>
        </div>
      </div>

      {/* Delete */}
      {/* Delete */}
      <button onClick={() => onRemove && onRemove(item?.id)} className="text-[#E63946] ml-2 p-1">
        <HiOutlineTrash size={18} />
      </button>
    </div>
  );
}
